import { render } from "./ContactView.vue?vue&type=template&id=4d4e7c7d"
import script from "./ContactView.vue?vue&type=script&lang=js"
export * from "./ContactView.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__